export default "__VITE_ASSET__d41b55e8__"